export default {
    getLoading(state) {
        return state.loading;
    }
}
